import React from "react";

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
const images = importAll(
  require.context("../assets/gallery", false, /\.(JPG|png|jpe?g|svg)$/)
);

const imagesNames = [];

for (const key in images) {
  if (Object.hasOwnProperty.call(images, key)) {
    imagesNames.push(images[key].default);
  }
}

const GalleryContext = React.createContext({
  photos: imagesNames,
});

export default GalleryContext;
